import axiosClient from "../requests/axiosCLient";
import { API_URLS } from "../../constants/constants";

export const getAboutUsDetails = () => {
  const url = API_URLS.aboutUsEndPoint;
  return axiosClient.get(url);
};
